import axios, { API_URL } from './BaseService';

export async function getPaperPredador() {
    const response = await axios.get(`${API_URL}/paper-predador`);
    return response.data;
}

export async function savePaperPredador(payload) {
    const response = await axios.post(`${API_URL}/paper-predador`, payload);
    return response.data;
}

export async function resetPaperPredador(cash) {
    const response = await axios.post(`${API_URL}/paper-predador/reset`, { cash });
    return response.data;
}
